import { Box, Flex, Image, LinkBox, LinkOverlay, Text } from '@chakra-ui/react';
import PublicationLink from '@components/publication/PublicationLink';

export default function RessourcePreview({
  imageSrc = null,
  imageAlt = null,
  mediaSize = null,
  roundedImage = null,
  ressourceLink = null,
  notificationsAmount = null,
  children,
  publication = null,
}) {
  let publicationLink = (
    <LinkOverlay as="a" href={ressourceLink}>
      <Text wordBreak="break-word">{children}</Text>
    </LinkOverlay>
  );

  if (publication) {
    publicationLink = (
      <PublicationLink publication={publication}>
        {publicationLink}
      </PublicationLink>
    );
  }

  return (
    <LinkBox
      display="flex"
      alignItems="center"
      gap={['1rem', '1.25rem']}
      transition="all 0.2s ease-in-out"
      _hover={{
        '& > a p': { textDecoration: 'underline' },
      }}
    >
      <Box
        minW={mediaSize ? mediaSize : '4.5rem'}
        maxW={mediaSize ? mediaSize : '4.5rem'}
        height={mediaSize ? mediaSize : '4.5rem'}
        borderRadius={roundedImage ? 'full' : 'none'}
        bg={!imageSrc && 'brand.100'}
        overflow="hidden"
      >
        {notificationsAmount && (
          <Flex height="100%" width="100%" align="center" justify="center">
            <Text color="white">{notificationsAmount}</Text>
          </Flex>
        )}
        {imageSrc && (
          <Image
            src={imageSrc}
            alt={imageAlt}
            height="100%"
            width="100%"
            objectFit="cover"
          />
        )}
      </Box>
      {publicationLink}
    </LinkBox>
  );
}
